import React from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { ModalConfirmation } from '@adsk/alloy-react-modal';
import PropTypes from 'prop-types';

const RemoveProjectAdminAccessConfirmationModal = ({
  onClose,
  onConfirm,
  show,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <ModalConfirmation
      data-testid="RemoveProjectAdminAccess_ModalConfirmation"
      isConfirmationButtonAlert
      message={<div>{T.translate('REMOVE_PA_ACCESS_CONFIRM_MODAL.BODY')}</div>}
      onClose={onClose}
      onConfirm={onConfirm}
      show={!!show}
      title={T.translate('REMOVE_PA_ACCESS_CONFIRM_MODAL.TITLE')}
    />
  );
};

RemoveProjectAdminAccessConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

RemoveProjectAdminAccessConfirmationModal.defaultProps = {
  show: false,
};

export default RemoveProjectAdminAccessConfirmationModal;
